'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
class Loader extends _react.PureComponent {
  render() {
    const component = this,
      props = this.props;
    let base_class = 'c-loader',
      class_name = props.className;
    const text = props.text ? /*#__PURE__*/_react.default.createElement("div", {
      className: "c-loader__txt"
    }, props.text) : undefined;
    if (typeof props.bemit === 'string') {
      class_name += ' ' + base_class + '--' + props.bemit;
    } else {
      props.bemit.forEach(function (bem_modifier, index) {
        class_name += ' ' + base_class + '--' + bem_modifier;
      });
    }
    const loader = /*#__PURE__*/_react.default.createElement("div", {
      className: class_name
    }, /*#__PURE__*/_react.default.createElement("svg", {
      className: "c-loader__svg",
      width: "135",
      height: "140",
      viewBox: "0 0 135 140",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor"
    }, /*#__PURE__*/_react.default.createElement("rect", {
      y: "10",
      width: "15",
      height: "120",
      rx: "4"
    }, /*#__PURE__*/_react.default.createElement("animate", {
      attributeName: "height",
      begin: "0.5s",
      dur: "1s",
      values: "120;110;100;90;80;70;60;50;40;140;120",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), /*#__PURE__*/_react.default.createElement("animate", {
      attributeName: "y",
      begin: "0.5s",
      dur: "1s",
      values: "10;15;20;25;30;35;40;45;50;0;10",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), /*#__PURE__*/_react.default.createElement("rect", {
      x: "30",
      y: "10",
      width: "15",
      height: "120",
      rx: "4"
    }, /*#__PURE__*/_react.default.createElement("animate", {
      attributeName: "height",
      begin: "0.25s",
      dur: "1s",
      values: "120;110;100;90;80;70;60;50;40;140;120",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), /*#__PURE__*/_react.default.createElement("animate", {
      attributeName: "y",
      begin: "0.25s",
      dur: "1s",
      values: "10;15;20;25;30;35;40;45;50;0;10",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), /*#__PURE__*/_react.default.createElement("rect", {
      x: "60",
      width: "15",
      height: "140",
      rx: "4"
    }, /*#__PURE__*/_react.default.createElement("animate", {
      attributeName: "height",
      begin: "0s",
      dur: "1s",
      values: "120;110;100;90;80;70;60;50;40;140;120",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), /*#__PURE__*/_react.default.createElement("animate", {
      attributeName: "y",
      begin: "0s",
      dur: "1s",
      values: "10;15;20;25;30;35;40;45;50;0;10",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), /*#__PURE__*/_react.default.createElement("rect", {
      x: "90",
      y: "10",
      width: "15",
      height: "120",
      rx: "4"
    }, /*#__PURE__*/_react.default.createElement("animate", {
      attributeName: "height",
      begin: "0.25s",
      dur: "1s",
      values: "120;110;100;90;80;70;60;50;40;140;120",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), /*#__PURE__*/_react.default.createElement("animate", {
      attributeName: "y",
      begin: "0.25s",
      dur: "1s",
      values: "10;15;20;25;30;35;40;45;50;0;10",
      calcMode: "linear",
      repeatCount: "indefinite"
    })), /*#__PURE__*/_react.default.createElement("rect", {
      x: "120",
      y: "10",
      width: "15",
      height: "120",
      rx: "4"
    }, /*#__PURE__*/_react.default.createElement("animate", {
      attributeName: "height",
      begin: "0.5s",
      dur: "1s",
      values: "120;110;100;90;80;70;60;50;40;140;120",
      calcMode: "linear",
      repeatCount: "indefinite"
    }), /*#__PURE__*/_react.default.createElement("animate", {
      attributeName: "y",
      begin: "0.5s",
      dur: "1s",
      values: "10;15;20;25;30;35;40;45;50;0;10",
      calcMode: "linear",
      repeatCount: "indefinite"
    }))), text);
    return loader;
  }
}
exports.default = Loader;
Loader.propTypes = {
  className: _propTypes.default.string,
  text: _propTypes.default.string,
  bemit: _propTypes.default.oneOfType([_propTypes.default.string.isRequired, _propTypes.default.array.isRequired])
};
Loader.defaultProps = {
  bemit: []
};
